/* WebComponentBillboard template */
import { Host, h, FunctionalComponent } from '@stencil/core'; // eslint-disable-line @typescript-eslint/no-unused-vars
import { PlaceholderIcons } from '@cewe-designsystem/util_placeholder_icons';
import { BillboardComponent } from './cwc-billboard';

/**
 * Definition of  parameters that the template needs to work.
 */
interface BillboardTemplateProps {
  /**
   * The class instance that provides controller functionality for the template
   */
  controller: BillboardComponent;

  // Specify parameters that are required to be passed down to the template here.
}

const BillboardTemplate: FunctionalComponent<BillboardTemplateProps> = ({ controller }) => (
  <Host>
    <cwc-billboard-pictures>
      <cwc-scrollable
        scrollbar-visibility="always"
        disable-vertical-scrollbar
        force-aspect-ratio={2 / 1}
        aspect-ratio-limit={400}
      >
        <slot />
      </cwc-scrollable>
    </cwc-billboard-pictures>
    <cwc-billboard-progress-bar />
    <ul>
      <li onClick={() => controller.onButtonClick('l')} data-disabled>
        <slot name={'scroll-left-icon'}>
          <svg viewBox={`0 0 24 24`}>{PlaceholderIcons.svgArrowLeft()}</svg>
        </slot>
      </li>
      <li onClick={() => controller.onButtonClick('r')}>
        <slot name={'scroll-left-icon'}>
          <svg viewBox={`0 0 24 24`}>{PlaceholderIcons.svgArrowRight()}</svg>
        </slot>
      </li>
    </ul>
  </Host>
);

export default BillboardTemplate;
